<template>
  <div>
    <van-nav-bar
      :title="$t('app.announcement.title')"
      :left-text=" $t('app.common.back') "
      left-arrow
      @click-left="$router.push('/member/announcement')"
    />
    <div style="padding: 20px 22px;">
      <p v-html="$store.state.announcement_title" class="title">
        {{ $store.state.announcement_title }}
      </p>
      <p v-html="$store.state.announcement_content" class="content">
        {{ $store.state.announcement_content }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "AnnouncementDetailed",
  data() {
    return {};
  },
  methods: {
    isLogin() {
      let that = this;
      if (!that.$store.state.loginType) {
        that.$router.push("/login");
      }
    },
  },
  mounted: function () {
    this.isLogin();
  },
};
</script>

<style scoped>
.navStyles {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
}
.title {
  width: 100%;
  margin: 2px 0px;
  font-size: 15px;
  text-align: center;
  white-space: nowrap;
  overflow: hidden !important;
  text-overflow: ellipsis;
}

.content {
  width: 100%;
  margin: 10px 0px;
  font-size: 13px;
}
.content >>> img {
  width: 100%;
}
.content >>> p {
  margin: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/AnnouncementDetailed.vue